/* eslint-disable prettier/prettier */
/* eslint-disable no-use-before-define */
/* eslint-disable arrow-parens */
import {
	useState,
	useEffect,
	useRef,
	Suspense,
	useCallback,
	useContext,
	KeyboardEventHandler,
	KeyboardEvent
} from "react";
import { useDebouncedCallback } from "use-debounce";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import {
	TextField,
	Checkbox,
	Paper,
	Grid,
	Button,
	Select,
	MenuItem,
	Tooltip,
	InputAdornment,
	IconButton,
	CheckboxProps
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { SnackbarProps } from "../../../../../../@types/snackbarAPI.types";
import { Validation } from "../../../../../../@types/validation.types";
import { AuthContext, GroupContext, UIContext } from "../../../../../../contexts";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { DynamicForm } from "../../../../../../@types/dynamicForm.types";
import { LazySnackbarAPI } from "../../../../../shared";
import { api } from "../../../../../../utils/api";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../constants/caption/dashboardHeader";
import validateEmail from "../../../../../../utils/commonFunctions/validateEmail";
import STATES from "../../../../../../constants/states";
import GENDERS from "../../../../../../constants/genders";
import CONTACT_LABELS from "../../../../../../constants/contactLabels";
import { EMPLOYEE_CLASS } from "../../../../../../constants/employeeClass";
import {
	PAY_FREQUENCIES,
	PAY_FREQUENCIES_V2,
	PAY_FREQUENCIES_V3,
	PAY_FREQUENCY
} from "../../../../../../constants/payFrequency";
import { RATE_TYPES, RATE_TYPE, RATE_TYPE_V2 } from "../../../../../../constants/rateType";
import initCapitalize from "../../../../../../utils/commonFunctions/initCapitalize";
import { MARITAL_STATUSES, MARITAL_STATUS } from "../../../../../../constants/maritalStatus";

import PersonAddIcon from "@material-ui/icons/PersonAdd";
import EventIcon from "@material-ui/icons/Event";
import ClearIcon from "@material-ui/icons/Clear";

import "../../../../../../globalStyles/paperFormStyles.css";
import "./createEmployee.css";
import ExtractRouteParams from "../../../../../../utils/commonFunctions/extractRouteParams";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { withStyles, Theme } from "@material-ui/core/styles";
import InfoIcon from "@material-ui/icons/Info";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { infoTitleMessage } from "../../../../../../constants/infoTitleMessage";
import prefixCharacterAddition from "../../../../../../utils/commonFunctions/prefixCharacterAddition";
import SnackbarAPICall from "../../../../../shared/snackbar/SnackbarAPICall";
import { GROUP_NUMBER } from "../../../../../../constants/groups";
import { Member } from "../../../../../../@types/member.types";
import SSNExistsModal from "./existsMemberModel.tsx/ExistMemberModel";
import CustomizedSwitches from "../../../../../shared/switchButton/SwitchButton";
import IdentityConflictModal from "./existsMemberModel.tsx/IdentityConflictModal";
import IdentityPersonConversionExistsModal from "./existsMemberModel.tsx/ExistMemberModel";
import AltIdExistsModal from "./existsMemberModel.tsx/AltIdExistsModal";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import ExistsOwnMemberModel from "./existsMemberModel.tsx/ExistsMemberOwnModel";

const date = new Date();
const maxDateRange = date.setDate(date.getDate());

const mailformat = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;
const specialCharacters = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const LightTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		maxWidth: 130,
		fontSize: 11
	}
}))(Tooltip);

const CreateEmployee = () => {
	const [employeeForm, setEmployeeForm] = useState<DynamicForm>();

	const [isTestEmployee, setIsTestEmployee] = useState<boolean>(false);
	const [assignedGroups, setAssignedGroups] = useState([]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedGroup, setSelectedGroup] = useState<any>();
	const [selectedGroupLocation, setSelectedGroupLocation] = useState<any[]>([]);
	const [emailExists, setEmailExists] = useState(false);
	const [checkInvalidEmail, setCheckInvalidEmail] = useState(false);
	const [existMember, setExistMember] = useState<Member>();
	const [pasted, setPasted] = useState(false);
	const [hasCreateClick, setHasCreateClick] = useState(false);
	const { user } = useContext(AuthContext); // Extracting logged in user from central storage.
	const { currentGroup } = useContext(GroupContext);
	const [ssnProvidedByGroup, setSsnProvidedByGroup] = useState<boolean>(false);
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const queryGroupNumber = useRouteParam("gn");
	const [paycheckConfig, setPaycheckConfig] = useState<any[]>([]);
	const [employeeClassConfig, setEmployeeClassConfig] = useState<any[]>([]);
	const [employee, setEmployee] = useState<any>({
		member_id: "", // This Id is mapped with Group HR (Group Specific)
		group_number: null,
		location_number: null,
		first_name: "",
		middle_name: "",
		last_name: "",
		email: "",
		alt_id: "",
		SSN: "",
		actual_SSN: "",
		date_of_birth: "",
		hire_date: "",
		gender: "",
		marital_status: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state: "",
		country: "USA - United States of America",
		ZIP: "",
		contact_label: "",
		phone_number: null,
		phone_extension: null,
		is_tobacco: false
	});
	const [reEnterSSN, setReEnterSSN] = useState("");
	const [paycheck, setPaycheck] = useState<any>({
		employment_start_date: "",
		// employment_end_date: "",
		employee_class: "",
		paycheck_start_date: "",
		// paycheck_end_date: "",
		pay_frequency: "",
		rate_type: "",
		hourly_base_pay_rate: null,
		// weekly_base_rate: null,
		// monthly_base_rate: null,
		base_pay_rate: null,
		buy_up_eligibility: null
	});
	const [validation, setValidation] = useState<Validation>({
		employee: {},
		reEnterSSN: "",
		paycheck: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	const navigate = useNavigate();
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const { setDashboardHeader } = useContext(UIContext);
	const [memberIdExists, setMemberIdExists] = useState<boolean>(false);
	const [SSNExists, setSSNExists] = useState<boolean>(false);

	const [showTooltip, setShowTooltip] = useState(false);
	// type IdentityConflictMode = "NONE" | "IDENTITY_EXISTS";

	// const [identityConflictMode, setIdentityConflictMode] =
	// 	useState<IdentityConflictMode>("NONE");

	// const [identityConflict, setIdentityConflict] = useState(false);
	// const [identityPerson, setIdentityPerson] = useState<any>(null);

	const [showIdentityConflictModal, setShowIdentityConflictModal] = useState(false);
	const [identityConflictMemberData, setIdentityConflictMemberData] = useState<any>(null);
	const [altIdForPayload, setAltIdForPayload] = useState<string>("");
	const [altIdModalOpen, setAltIdModalOpen] = useState(false);
	const [existingAltId, setExistingAltId] = useState<string>("");

	const handleIdentityConflictConfirm = () => {
		// The alt_id with @ suffix is already set in the form
		// Close the modal and proceed with form submission
		setShowIdentityConflictModal(false);

		// Optionally auto-submit or just let user click Create Dependent
		// handleCreateDependent({ preventDefault: () => {} } as any);
	};

	// const searchPersonIdentity = useDebouncedCallback(async () => {
	// 	if (!employee.first_name || !employee.date_of_birth) return;

	// 	try {
	// 		const response = (await api.find.checkPersonAlreadyExists({
	// 			first_name: employee.first_name,
	// 			last_name: employee.last_name || "",
	// 			date_of_birth: employee.date_of_birth,
	// 			employee_SSN: employee.employee_SSN,
	// 			group_number: employee.group_number
	// 		})) as {
	// 			personExists: boolean;
	// 			dependentAlreadyExistsForEmployee?: boolean;
	// 			person?: {
	// 				first_name?: string;
	// 				last_name?: string;
	// 				date_of_birth?: string;
	// 				relationship?: string;
	// 			};
	// 			relationships?: any[];
	// 		};

	// 		setIdentityConflict(true);
	// 		setIdentityPerson(response.person);
	// 		setIdentityConflictMode("IDENTITY_EXISTS");

	// 	} catch (err) {
	// 		console.error("[searchPersonIdentity]", err);
	// 	}
	// }, 600);

	// useEffect(() => {
	// 	// Only identity check, not SSN
	// 	if (employee.first_name && employee.date_of_birth) {
	// 		searchPersonIdentity();
	// 	}
	// }, [employee.first_name, employee.last_name, employee.date_of_birth]);

	const findMemberSSN = useDebouncedCallback(async (value: string) => {
		// console.log("Inside SSN");
		if (value !== "") {
			const findSSNQuery = {
				group_number: employee.group_number,
				SSN: value
			};
			try {
				const SSN = await api.find.findMemberSSN(findSSNQuery);
				if (SSN === false) {
					setSSNExists(false);
					setExistMember(undefined);
				} else {
					setSSNExists(true);
					setExistMember(SSN);
					setIsModalOpen(true);
				}
			} catch (error) {
				console.error("Error finding SSN:", error);
				setExistMember(undefined);
			}
		} else {
			setSSNExists(false);
			setExistMember(undefined);
		}
	}, 500);

	const handleClose = () => setIsModalOpen(false);
	const findMemberId = useDebouncedCallback(async (value: string) => {
		if (value !== "") {
			const findMemberIdQuery = {
				group_number: employee.group_number,
				member_id: value
			};
			const email = await api.find.findMemberId(findMemberIdQuery);
			if (email === false) {
				setMemberIdExists(false);
			} else {
				setMemberIdExists(true);
			}
		} else {
			setMemberIdExists(false);
		}
	}, 500);

	const findMemberEmail = useDebouncedCallback(async (value: string) => {
		if (value !== "") {
			const findEmailQuery = {
				group_number: employee.group_number,
				email: value
			};
			const email = await api.find.findMemberEmail(findEmailQuery);
			if (email === false) {
				setEmailExists(false);
			} else {
				setEmailExists(true);
			}
		} else {
			setEmailExists(false);
		}
	}, 500);

	const handleValidation = useCallback(async () => {
		const {
			member_id,
			first_name,
			last_name,
			SSN,
			date_of_birth,
			hire_date,
			gender,
			marital_status,
			email,
			address_line_1,
			city,
			state,
			ZIP,
			contact_label,
			phone_number,
			phone_extension,
			group_number,
			location_number
		} = employee;
		const {
			employment_start_date,
			// employment_end_date,
			employee_class,
			paycheck_start_date,
			// paycheck_end_date,
			pay_frequency,
			rate_type,
			hourly_base_pay_rate,
			base_pay_rate,
			// weekly_base_rate,
			// monthly_base_rate,
			buy_up_eligibility
		} = paycheck;
		_validation.current = {
			...validation,
			employee: {},
			reEnterSSN: "",
			paycheck: {},
			status: "invalid"
		};
		let flag = true;

		// employee validation checking
		if (group_number === null) {
			_validation.current.employee["group_number"] = "Group is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (group_number === null) {
			if (location_number === null) {
				_validation.current.employee["location_number"] = "Please, Select the group first!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (group_number !== null) {
			if (location_number === null) {
				_validation.current.employee["location_number"] = "Location is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (member_id.length === 0 || member_id === undefined) {
			_validation.current.employee["member_id"] = "Employee Id is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (first_name.length === 0) {
			_validation.current.employee["first_name"] = "First Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (last_name.length === 0) {
			_validation.current.employee["last_name"] = "Last Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		const isSSNRequired = ssnProvidedByGroup === true || selectedGroup?.SSN_provided_by_group === true;
		if (isSSNRequired) {
			// SSN is required by group
			if (SSN.length === 0) {
				_validation.current.employee["SSN"] = "SSN is required by group policy";
				_validation.current["status"] = "invalid";
				flag = false;
			}
			if (SSN !== null && SSN !== "") {
				const _SSN = SSN.replaceAll("-", "");
				if (String(_SSN).length !== 9) {
					_validation.current.employee["SSN"] = "Enter correct 9 digit SSN";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
			if (SSN !== "") {
				if (reEnterSSN === "") {
					_validation.current["reEnterSSN"] = "Re-Enter SSN cannot be Empty, as SSN is Given";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
			if (SSN !== "") {
				const _SSN = SSN.replaceAll("-", "");
				const _reEnterSSN = reEnterSSN.replaceAll("-", "");
				if (_SSN !== _reEnterSSN) {
					_validation.current["reEnterSSN"] = "Must be same as SSN";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
			if (reEnterSSN !== "") {
				if (SSN === "") {
					_validation.current.employee["SSN"] = "SSN cannot be Empty, as Re-Enter SSN is Given";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
		} else {
			// ALT ID mode - either SSN or ALT ID must be provided
			const cleanSSN = SSN.replaceAll("-", "");
			const hasSSN = cleanSSN.length === 9;
			const hasAltId = employee.alt_id && employee.alt_id.length > 0;

			if (!hasSSN && !hasAltId) {
				_validation.current.employee["alt_id"] = "Either SSN or ALT ID is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}

			// Only validate SSN format if SSN is provided (optional field in ALT ID mode)
			if (cleanSSN.length > 0 && cleanSSN.length !== 9) {
				_validation.current.employee["SSN"] = "Enter correct 9 digit SSN";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		// if (isSSNRequired) {
		// 	if (SSN.length === 0) {
		// 		_validation.current.employee["SSN"] = "SSN is required";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// 	if (SSN !== null) {
		// 		if (SSN !== "") {
		// 			const _SSN = SSN.replaceAll("-", "");
		// 			if (String(_SSN).length !== 9) {
		// 				_validation.current.employee["SSN"] = "Enter correct 9 digit SSN";
		// 				_validation.current["status"] = "invalid";
		// 				flag = false;
		// 			}
		// 		}
		// 	}
		// 	if (SSN !== "") {
		// 		const _SSN = SSN.replaceAll("-", "");
		// 		if (String(_SSN).length !== 9) {
		// 			_validation.current.employee["SSN"] = "Enter correct 9 digit SSN";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}
		// 	if (SSN !== "") {
		// 		if (reEnterSSN === "") {
		// 			_validation.current["reEnterSSN"] = "Re-Enter SSN cannot be Empty, as SSN is Given";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}
		// 	if (SSN !== "") {
		// 		const _SSN = SSN.replaceAll("-", "");
		// 		const _reEnterSSN = reEnterSSN.replaceAll("-", "");
		// 		if (_SSN !== _reEnterSSN) {
		// 			_validation.current["reEnterSSN"] = "Must be same as SSN";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}
		// 	if (reEnterSSN !== "") {
		// 		if (SSN === "") {
		// 			_validation.current.employee["SSN"] = "SSN cannot be Empty, as Re-Enter SSN is Given";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}

		// }

		if (String(date_of_birth).length === 0) {
			_validation.current.employee["date_of_birth"] = "Date of birth is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (String(hire_date).length === 0) {
			_validation.current.employee["hire_date"] = "Hire Date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (hire_date.length !== 0) {
			if (date_of_birth.length === 0) {
				_validation.current.employee["date_of_birth"] = "Date of birth is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (hire_date.length !== 0) {
			const hireDate = new Date(hire_date).getFullYear();
			const DOB = new Date(date_of_birth).getFullYear();
			const hireDateTime = new Date(hire_date).getTime();
			const DOBtime = new Date(date_of_birth).getTime();
			const age = hireDate - DOB;
			if (age <= 16) {
				_validation.current.employee["date_of_birth"] = "Age should be 16 years or above!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
			if (hireDateTime < DOBtime) {
				_validation.current.employee["hire_date"] = "Hire date cannot be less than Date of Birth!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (gender.length === 0) {
			_validation.current.employee["gender"] = "Gender is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (marital_status.length === 0) {
			_validation.current.employee["marital_status"] = "Marital Status is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (contact_label.length === 0) {
			_validation.current.employee["contact_label"] = "Contact Label is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (email.length === 0) {
			_validation.current.employee["email"] = "Email is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (email.length !== 0) {
			if (!email.match(mailformat)) {
				_validation.current.employee["email"] = "Valid Email is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
			setCheckInvalidEmail(false);
			if (!validateEmail(email)) {
				setCheckInvalidEmail(true);
			}
		}
		if (phone_number === null || phone_number === "") {
			_validation.current.employee["phone_number"] = "Phone number is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (phone_number !== null) {
			if (String(phone_number).length !== 10) {
				_validation.current.employee["phone_number"] = "Enter valid 10 digit phone number";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		// if (phone_extension === null || phone_extension === "") {
		// _validation.current.employee["phone_extension"] = "Phone extension is required";
		// _validation.current["status"] = "invalid";
		// flag = false;
		// }
		if (phone_extension !== null) {
			if (String(phone_extension).length > 3) {
				_validation.current.employee["phone_extension"] = "Enter Valid 3 digit Phone extension";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (address_line_1.length === 0) {
			_validation.current.employee["address_line_1"] = "Address line 1 is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (city.length === 0) {
			_validation.current.employee["city"] = "City is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (state.length === 0) {
			_validation.current.employee["state"] = "State is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length === 0) {
			_validation.current.employee["ZIP"] = "ZIP Code is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length !== 0) {
			const _zip = ZIP.replaceAll("-", "");
			if (_zip.length !== 5 && _zip.length !== 9) {
				_validation.current.employee["ZIP"] = "Enter 5 or 9 digit ZIP Code!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		// paycheck validation checking
		if (String(employment_start_date).length === 0) {
			_validation.current.paycheck["employment_start_date"] = "Employment Start date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		// if (String(employment_end_date).length !== 0) {
		// const employmentStartDate = new Date(employment_start_date).getTime();
		// const employmentEndDate = new Date(employment_end_date).getTime();
		// if (employmentStartDate > employmentEndDate) {
		// _validation.current.paycheck["end_date"] = "Employment End date cannot be less than start date";
		// _validation.current["status"] = "invalid";
		// flag = false;
		// }
		// }
		if (String(paycheck_start_date).length === 0) {
			_validation.current.paycheck["paycheck_start_date"] = "Start date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		// if (String(paycheck_end_date).length !== 0) {
		// const paycheckStartDate = new Date(paycheck_start_date).getTime();
		// const paycheckEndDate = new Date(paycheck_end_date).getTime();
		// if (paycheckStartDate > paycheckEndDate) {
		// _validation.current.paycheck["paycheck_end_date"] =
		// "Paycheck End date cannot be less than Paycheck Start Date";
		// _validation.current["status"] = "invalid";
		// flag = false;
		// }
		// }
		if (pay_frequency.length === 0) {
			_validation.current.paycheck["pay_frequency"] = "Pay frequency is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (rate_type.length === 0) {
			_validation.current.paycheck["rate_type"] = "Rate type is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.weekly) {
			if (rate_type === RATE_TYPE_V2.hourly_rate) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (hourly_base_pay_rate === null || hourly_base_pay_rate === 0) {
					_validation.current.paycheck["hourly_base_pay_rate"] = "Hourly base pay rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.monthly) {
			if (rate_type === RATE_TYPE_V2.hourly_rate) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (hourly_base_pay_rate === null || hourly_base_pay_rate === 0) {
					_validation.current.paycheck["hourly_base_pay_rate"] = "Hourly base pay rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.biweekly) {
			if (rate_type === RATE_TYPE_V2.hourly_rate) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (hourly_base_pay_rate === null || hourly_base_pay_rate === 0) {
					_validation.current.paycheck["hourly_base_pay_rate"] = "Hourly base pay rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.weekly) {
			if (rate_type === RATE_TYPE_V2.fixed) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (base_pay_rate === null || base_pay_rate === 0) {
					_validation.current.paycheck["base_pay_rate"] = "Weekly base rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.monthly) {
			if (rate_type === RATE_TYPE_V2.fixed) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (base_pay_rate === null || base_pay_rate === 0) {
					_validation.current.paycheck["base_pay_rate"] = "Monthly base rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (pay_frequency === PAY_FREQUENCIES_V3.biweekly) {
			if (rate_type === RATE_TYPE_V2.fixed) {
				// if (queryGroupNumber === GROUP_NUMBER.PROGRESSIVE_LABORATORIES) {
				// } else {
				if (base_pay_rate === null || base_pay_rate === 0) {
					_validation.current.paycheck["base_pay_rate"] = "Monthly base rate is required";
					_validation.current["status"] = "invalid";
					flag = false;
				}
				// }
			}
		}
		if (employee_class.length === 0) {
			_validation.current.paycheck["employee_class"] = "Employee class is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (buy_up_eligibility === null) {
			_validation.current.paycheck["buy_up_eligibility"] = "Buy up eligibility is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [employee, paycheck, reEnterSSN, validation, selectedGroup, ssnProvidedByGroup]);

	// const handleGroupChange = useCallback(
	// (event: React.ChangeEvent<HTMLInputElement>) => {
	// const { value } = event.target;

	// setEmployee(
	// Object.assign({}, employee, {
	// // group_number: value
	// group_number: 220
	// })
	// );

	// // Storing and Checking of Particular group for all locations of that group.
	// assignedGroups.forEach((group: any) => {
	// if (group.group_number === value) {
	// setSelectedGroup(Object.assign({}, group));
	// }
	// });
	// },
	// [assignedGroups, employee]
	// );

	const handleSelectGroup = useCallback(async () => {
		assignedGroups.forEach((group: any) => {
			// This condition is to check assigned group with the parameter group
			if (group.group_number === queryGroupNumber) {
				setSelectedGroup(Object.assign({}, group));

				setEmployee(
					Object.assign({}, employee, {
						group_number: group.group_number
					})
				);
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [assignedGroups]);

	const handleKeyCheck = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			let { value } = event.target as HTMLInputElement;
			const { name } = event.target as HTMLInputElement;
			const eventKey = event.key;

			if (name === "ZIP") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setEmployee(Object.assign({}, employee, { [name]: value }));
					}
				}
			}
			if (name === "SSN") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 4) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setEmployee(Object.assign({}, employee, { [name]: value }));
					}
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.lastIndexOf("-");
						value = value.substring(0, index);
						setEmployee(Object.assign({}, employee, { [name]: value }));
					}
				}
			}
			if (name === "re_enter_SSN") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 4) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setReEnterSSN(value);
					}
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.lastIndexOf("-");
						value = value.substring(0, index);
						setReEnterSSN(value);
					}
				}
			}
		},
		[setEmployee, employee]
	);

	const handlePaste = (event: React.ClipboardEvent<HTMLInputElement | HTMLDivElement>) => {
		const { name } = event.target as HTMLInputElement;
		if (name === "SSN" || name === "ZIP" || name === "re_enter_SSN") {
			setPasted(true);
			setTimeout(() => null, 2000);
		}
	};

	const handleReEnterSSNChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			let { value } = event.target;

			if (!pasted) {
				const _value = Number(value.replaceAll("-", ""));
				if (!isNaN(_value as any)) {
					let ssn = value;
					if (
						!(
							/^[0-9]{0,3}$/.test(value) ||
							/^[0-9]{3}-[0-9]{0,2}$/.test(value) ||
							/^[0-9]{3}-[0-9]{2}-[0-9]{0,4}$/.test(value)
						)
					) {
						// value = value.substr(0, ssn.length - 1);
						ssn = ssn.substring(0, ssn.length - 1);
					} else if (ssn.length === 6) {
						ssn = ssn.substring(0, 7) + "-" + ssn.substring(7);
					} else if (ssn.length === 3) {
						// value = value.substr(0, 3) + "-" + value.substr(3);
						ssn = ssn.substring(0, 3) + "-" + ssn.substring(3);
					}
					setReEnterSSN(ssn);
				} else {
					event.target.value = "";
					event.target.value = reEnterSSN;
				}
			} else {
				// console.log("Pasted");
				setPasted(false);
				if (!isNaN(value as any)) {
					if (value.length > 9) {
						event.target.value = "";
						event.target.value = reEnterSSN;
						alert("Please enter a valid 9 digit SSN!");
					} else {
						// console.log("Inside Number");
						const ssn = value;

						if (ssn.length === 4) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						} else if (ssn.length === 5) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						} else if (ssn.length >= 6 && ssn.length <= 9) {
							value = value.substring(0, 3) + "-" + value.substring(3, 2) + "-" + value.substring(5);
						}
						setReEnterSSN(value);
					}
				} else {
					// console.log("Inside alpha-numeric");
					let ssnValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
					//console.log("replaced string", ssnValue);
					alert("You have pasted alpha-numeric SSN!");

					if (ssnValue.length > 9) {
						event.target.value = "";
						event.target.value = reEnterSSN as unknown as string;
						alert("Please enter a valid SSN!");
					} else {
						const ssn = ssnValue;

						if (ssn.length === 4) {
							ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
						} else if (ssn.length === 5) {
							ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
						} else if (ssn.length >= 6 && ssn.length <= 9) {
							ssnValue =
								ssnValue.substring(0, 3) + "-" + ssnValue.substring(3, 2) + "-" + ssnValue.substr(5);
						}

						setReEnterSSN(ssnValue);
					}
				}
			}
		},
		[pasted, reEnterSSN]
	);

	const handleEmployeeChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			let { value } = event.target;
			const { name } = event.target;

			if (name === "first_name") {
				const regex = /^[a-zA-Z\s',.]+$/g;
				if (value.match(regex) || value === "") {
					value = value.slice(0, 1).toUpperCase() + value.slice(1);
					setEmployee(Object.assign({}, employee, { [name]: value }));
				} else if (/\s/g.test(value)) {
					setEmployee(Object.assign({}, employee, { [name]: value }));
				}
			} else if (name === "middle_name") {
				const regex = /^[a-zA-Z\s',.]+$/g;
				if (value.match(regex) || value === "") {
					value = value.slice(0, 1).toUpperCase() + value.slice(1);
					setEmployee(Object.assign({}, employee, { [name]: value }));
				} else if (/\s/g.test(value)) {
					setEmployee(Object.assign({}, employee, { [name]: value }));
				}
			} else if (name === "last_name") {
				const regex = /^[a-zA-Z\s',.-]+$/g;
				if (value.match(regex) || value === "") {
					value = value.slice(0, 1).toUpperCase() + value.slice(1);
					setEmployee(Object.assign({}, employee, { [name]: value }));
				} else if (/\s/g.test(value)) {
					setEmployee(Object.assign({}, employee, { [name]: value }));
				}
			} else if (name === "member_id") {
				findMemberId(value);
				setEmployee(Object.assign({}, employee, { [name]: value }));
			} else if (name === "email") {
				// findMemberEmail(value);
				setEmployee(Object.assign({}, employee, { [name]: value }));
			} else if (name === "SSN") {
				const _ssn = value.replaceAll("-", "");
				findMemberSSN(_ssn);
				if (!pasted) {
					// console.log("Not Pasted");
					const _value = Number(value.replaceAll("-", ""));
					if (!isNaN(_value)) {
						const ssn = value;
						if (
							!(
								/^[0-9]{0,3}$/.test(value) ||
								/^[0-9]{3}-[0-9]{0,2}$/.test(value) ||
								/^[0-9]{3}-[0-9]{2}-[0-9]{0,4}$/.test(value)
							)
						) {
							value = value.substring(0, value.length - 1);
						} else if (ssn.length === 6) {
							value = value.substring(0, 7) + "-" + value.substring(7);
						} else if (ssn.length === 3) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						}

						setEmployee(Object.assign({}, employee, { [name]: value }));
					} else {
						event.target.value = "";
						event.target.value = employee.SSN;
					}
				} else {
					// console.log("Pasted");
					setPasted(false);
					if (!isNaN(value as any)) {
						if (value.length > 9) {
							event.target.value = "";
							event.target.value = employee.SSN;
							alert("Please enter a valid 9 digit SSN!");
						} else {
							// console.log("Inside Number");
							const ssn = value;

							if (ssn.length === 4) {
								value = value.substring(0, 3) + "-" + value.substring(3);
							} else if (ssn.length === 5) {
								value = value.substring(0, 3) + "-" + value.substring(3);
							} else if (ssn.length >= 6 && ssn.length <= 9) {
								value = value.substring(0, 3) + "-" + value.substring(3, 2) + "-" + value.substring(5);
							}

							setEmployee(Object.assign({}, employee, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						let ssnValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
						//console.log("replaced string", ssnValue);
						alert("You have pasted alpha-numeric SSN!");

						if (ssnValue.length > 9) {
							event.target.value = "";
							event.target.value = employee.SSN;
							alert("Please enter a valid SSN!");
						} else {
							const ssn = ssnValue;

							if (ssn.length === 4) {
								ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
							} else if (ssn.length === 5) {
								ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
							} else if (ssn.length >= 6 && ssn.length <= 9) {
								ssnValue =
									ssnValue.substring(0, 3) +
									"-" +
									ssnValue.substring(3, 2) +
									"-" +
									ssnValue.substring(5);
							}

							setEmployee(Object.assign({}, employee, { [name]: ssnValue }));
						}
					}
				}
			} else if (name === "ZIP") {
				if (!pasted) {
					const _value = Number(value.replaceAll("-", ""));
					if (!isNaN(_value) && value.length <= 10) {
						const zip = value;
						if (zip.length === 6) {
							value = value.substring(0, 5) + "-" + value.substring(5);
						}

						// console.log("ZIP Event", event.target.value);

						setEmployee(
							Object.assign({}, employee, {
								[name]: value
							})
						);
					} else {
						event.target.value = "";
						event.target.value = employee.ZIP;
					}
				} else {
					setPasted(false);
					if (!isNaN(value as any)) {
						if (value.length > 9) {
							event.target.value = "";
							event.target.value = employee.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							// console.log("Inside Number");
							const zip = value;

							if (zip.length >= 6 && zip.length <= 9) {
								value = value.substring(0, 5) + "-" + value.substring(5);
							}

							setEmployee(Object.assign({}, employee, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						let zipValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");

						//console.log("replaced string", zipValue);
						alert("You have pasted alpha-numeric ZIP!");

						if (zipValue.length > 9) {
							event.target.value = "";
							event.target.value = employee.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							const zip = zipValue;

							if (zip.length >= 6 && zip.length <= 9) {
								zipValue = zipValue.substring(0, 5) + "-" + zipValue.substring(5);
							}

							setEmployee(Object.assign({}, employee, { [name]: zipValue }));
						}
					}
				}
			} else if (name === "phone_number") {
				if (!isNaN(value as any)) {
					if (value.length <= 10) {
						setEmployee(Object.assign({}, employee, { [name]: value }));
					} else {
						event.target.value = employee.phone_number ? (employee.phone_number as unknown as string) : "";
						alert("Phone Number cannot be greater 10 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = employee.phone_number ? (employee.phone_number as unknown as string) : "";
				}
			} else if (name === "phone_extension") {
				if (!isNaN(value as any)) {
					if (value.length <= 3) {
						setEmployee(Object.assign({}, employee, { [name]: value }));
					} else {
						event.target.value = employee.phone_extension
							? (employee.phone_extension as unknown as string)
							: "";
						alert("Phone Extension cannot be greater 3 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = employee.phone_extension
						? (employee.phone_extension as unknown as string)
						: "";
				}
			} else {
				setEmployee(Object.assign({}, employee, { [name]: value }));
			}
		},
		[employee, findMemberId, findMemberSSN, pasted]
	);

	const handleConfirm = () => {
		// Close the modal
		handleClose();
	};
	// console.log("Confirm -->", employee);

	const handleWeeklyPaycheckChange = useCallback(
		(value: number) => {
			// console.log("weekly hourly (this) -> ", value);
			const valueString: string = value.toString();
			const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
			if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
				return;
			}
			setPaycheck(
				Object.assign({}, paycheck, {
					hourly_base_pay_rate: value * 1,
					weekly_base_rate: Number((value * 40).toFixed(2)),
					monthly_base_rate: 0
				})
			);
		},
		[paycheck]
	);

	const handleMonthlyPaycheckChange = useCallback(
		(value: number) => {
			// console.log("monthly hourly -> ", value);
			const valueString: string = value.toString();
			const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
			if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
				return;
			}
			setPaycheck(
				Object.assign({}, paycheck, {
					hourly_base_pay_rate: value * 1,
					monthly_base_rate: Number((value * 160).toFixed(2)),
					weekly_base_rate: 0
				})
			);
		},
		[paycheck]
	);

	const handleWeekHourlyPaycheckChange = useCallback(
		(value: number) => {
			// console.log("weekly base -> ", value);
			const valueString: string = value.toString();
			const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
			if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
				return;
			}
			setPaycheck(
				Object.assign({}, paycheck, {
					hourly_base_pay_rate: Number((value / 40).toFixed(2)),
					weekly_base_rate: value * 1,
					monthly_base_rate: 0
				})
			);
		},
		[paycheck]
	);

	const handleMonthHourlyPaycheckChange = useCallback(
		(value: number) => {
			// console.log("monthly base -> ", value);
			const valueString: string = value.toString();
			const decimalIndex = valueString.indexOf(".") !== -1 ? valueString.indexOf(".") : valueString.indexOf(",");
			if (decimalIndex !== -1 && valueString.length - decimalIndex > 3) {
				return;
			}
			setPaycheck(
				Object.assign({}, paycheck, {
					hourly_base_pay_rate: (value / 160).toFixed(2),
					monthly_base_rate: value * 1,
					weekly_base_rate: 0
				})
			);
		},
		[paycheck]
	);

	useEffect(() => {
		if (currentGroup?.SSN_provided_by_group === true) {
			setSsnProvidedByGroup(true);
		} else {
			setSsnProvidedByGroup(false);
		}
	}, [currentGroup]);
	// const handlePaycheckChange = useCallback(
	// 	(event: React.ChangeEvent<HTMLInputElement>) => {
	// 		const { name, value } = event.target;

	// 		if (name === "pay_frequency") {
	// 			setPaycheck(
	// 				Object.assign({}, paycheck, {
	// 					pay_frequency: value,
	// 					hourly_base_pay_rate: 0,
	// 					weekly_base_rate: 0,
	// 					monthly_base_rate: 0
	// 				})
	// 			);
	// 		} else if (name === "pay_frequency" && paycheck.rate_type !== "") {
	// 			setPaycheck(
	// 				Object.assign({}, paycheck, {
	// 					hourly_base_pay_rate: 0,
	// 					weekly_base_rate: 0,
	// 					monthly_base_rate: 0
	// 				})
	// 			);
	// 		} else if (name === "rate_type") {
	// 			setPaycheck(
	// 				Object.assign({}, paycheck, {
	// 					rate_type: value,
	// 					hourly_base_pay_rate: 0,
	// 					weekly_base_rate: 0,
	// 					monthly_base_rate: 0
	// 				})
	// 			);
	// 		} else if (
	// 			name === "hourly_base_pay_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCY.weekly &&
	// 			paycheck.rate_type === RATE_TYPE.hourly_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleWeeklyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.hourly_base_pay_rate
	// 					? (paycheck.hourly_base_pay_rate as unknown as string)
	// 					: "";
	// 			}
	// 		} else if (
	// 			name === "hourly_base_pay_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCY.monthly &&
	// 			paycheck.rate_type === RATE_TYPE.hourly_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleMonthlyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.hourly_base_pay_rate
	// 					? (paycheck.hourly_base_pay_rate as unknown as string)
	// 					: "";
	// 			}
	// 		} else if (
	// 			name === "weekly_base_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCY.weekly &&
	// 			paycheck.rate_type === RATE_TYPE.flat_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleWeekHourlyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.weekly_base_rate
	// 					? (paycheck.weekly_base_rate as unknown as string)
	// 					: "";
	// 			}
	// 		} else if (
	// 			name === "monthly_base_rate" &&
	// 			paycheck.pay_frequency === PAY_FREQUENCY.monthly &&
	// 			paycheck.rate_type === RATE_TYPE.flat_rate
	// 		) {
	// 			if (!isNaN(value as any)) {
	// 				handleMonthHourlyPaycheckChange(Number(value));
	// 			} else {
	// 				event.target.value = "";
	// 				event.target.value = paycheck.monthly_base_rate
	// 					? (paycheck.monthly_base_rate as unknown as string)
	// 					: "";
	// 			}
	// 		} else if (name === "buy_up_eligibility") {
	// 			if (value === "Yes")
	// 				setPaycheck(
	// 					Object.assign({}, paycheck, {
	// 						buy_up_eligibility: true
	// 					})
	// 				);
	// 			else
	// 				setPaycheck(
	// 					Object.assign({}, paycheck, {
	// 						buy_up_eligibility: false
	// 					})
	// 				);
	// 		} else {
	// 			setPaycheck(Object.assign({}, paycheck, { [name]: value }));
	// 		}
	// 	},
	// 	[
	// 		handleMonthHourlyPaycheckChange,
	// 		handleMonthlyPaycheckChange,
	// 		handleWeekHourlyPaycheckChange,
	// 		handleWeeklyPaycheckChange,
	// 		paycheck
	// 	]
	// );

	const getHourlyMultiplication = (pay_frequency: string) => {
		const config = paycheckConfig.find((hour_mul) => hour_mul.pay_frequency === pay_frequency);
		return config ? config.hourly_multiplication : 1;
	};

	const handlePaycheckChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, value } = event.target;

			if (name === "pay_frequency") {
				setPaycheck(
					Object.assign({}, paycheck, {
						pay_frequency: value,
						hourly_base_pay_rate: 0,
						base_pay_rate: 0
					})
				);
				return;
			}

			if (name === "rate_type") {
				setPaycheck(
					Object.assign({}, paycheck, {
						rate_type: value,
						hourly_base_pay_rate: 0,
						base_pay_rate: 0
					})
				);
				return;
			}

			// Handle hourly -> base conversion
			if (name === "hourly_base_pay_rate" && paycheck.rate_type === RATE_TYPE_V2.hourly_rate) {
				if (!isNaN(value as any)) {
					const multiplier = getHourlyMultiplication(paycheck.pay_frequency);
					setPaycheck(
						Object.assign({}, paycheck, {
							hourly_base_pay_rate: Number(value),
							base_pay_rate: Number((Number(value) * multiplier).toFixed(2))
						})
					);
				}
				return;
			}

			// Handle base -> hourly conversion
			if (name === "base_pay_rate" && paycheck.rate_type === RATE_TYPE_V2.fixed) {
				if (!isNaN(value as any)) {
					const multiplier = getHourlyMultiplication(paycheck.pay_frequency);
					setPaycheck(
						Object.assign({}, paycheck, {
							base_pay_rate: Number(value),
							hourly_base_pay_rate: Number((Number(value) / multiplier).toFixed(2))
						})
					);
				}
				return;
			}

			// boolean case
			if (name === "buy_up_eligibility") {
				setPaycheck(
					Object.assign({}, paycheck, {
						buy_up_eligibility: value === "Yes"
					})
				);
				return;
			}
			setPaycheck(Object.assign({}, paycheck, { [name]: value }));
		},
		[paycheck]
	);

	const handleEmployeeDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const date = new Date(_date as Date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			if (name === "hire_date") {
				setPaycheck(
					Object.assign({}, paycheck, {
						employment_start_date: parsedDate,
						paycheck_start_date: parsedDate
					})
				);
			}

			setEmployee(Object.assign({}, employee, { [name]: parsedDate }));
		},
		[employee, paycheck]
	);

	const handlePaycheckDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const date = new Date(_date as Date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			setPaycheck(Object.assign({}, paycheck, { [name]: parsedDate }));
		},
		[paycheck]
	);

	const handleClearDateField = useCallback(
		(event: React.MouseEvent<HTMLButtonElement, MouseEvent>, name: string, schema: string) => {
			// console.log("Schema", schema);
			if (schema === "employee") {
				if (name === "hire_date") {
					const _paycheck = {
						...paycheck,
						employment_start_date: null,
						paycheck_start_date: null
					};
					setPaycheck(Object.assign({}, _paycheck));
					setEmployee(Object.assign({}, employee, { [name]: null }));
				} else setEmployee(Object.assign({}, employee, { [name]: null }));
			}

			if (schema === "paycheck") setPaycheck(Object.assign({}, paycheck, { [name]: null }));
		},
		[employee, paycheck]
	);

	const getAssignGroups = useCallback(async () => {
		const params = {
			user_id: user?._id
		};
		const response = await api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params);

		if (response) {
			const _assignedGroups: any[] = [];
			response.groupsAndLocations.forEach((group: any) => {
				if (group.assigned_group_info) {
					_assignedGroups.push(group);
				}
			});

			setAssignedGroups(Object.assign([], _assignedGroups));
			const currentGroup = _assignedGroups.find((group: any) => group.group_number === queryGroupNumber);
			if (currentGroup) {
				setPaycheckConfig(Object.assign([], currentGroup?.paycheck_config));
			}
			setEmployeeClassConfig(Object.assign([], currentGroup?.employee_class));
		}
	}, [user?._id, queryGroupNumber]);

	const handleReturnToMembers = useCallback(() => {
		const pathname = `/employer/members?${routeParam}`;
		navigate(pathname);
	}, []);

	const handleEnableCheckbox = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, checked } = event.target;
			setEmployee(Object.assign({}, employee, { [name]: checked }));
		},
		[employee]
	);

	const handleCreateEmployee = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const validation = await handleValidation();
				if (validation === "valid") {
					const { date_of_birth, hire_date } = employee;
					const DOB = new Date(date_of_birth);
					const hireDate = new Date(hire_date);

					// fix with the altid working are comment me
					// let ssnForPayload: string;
					const isSSNMode = ssnProvidedByGroup === true || selectedGroup?.SSN_provided_by_group === true;

					let ssnForPayload: string;
					let actualSSN: string | null;

					if (altIdForPayload && altIdForPayload.endsWith("@")) {
						// This covers both:
						// - SSN conversion from DEPENDENT role (set via SSN modal)
						// - ALT ID conversion from DEPENDENT role (set via ALT ID modal)
						ssnForPayload = altIdForPayload;
						actualSSN = altIdForPayload;
						console.log("Using converted ID with @ suffix:", ssnForPayload);
					}
					// PRIORITY 2: Group requires SSN
					else if (isSSNMode) {
						ssnForPayload = employee.SSN?.replace(/-/g, "") || "";
						actualSSN = ssnForPayload;

						if (!ssnForPayload) {
							alert("SSN is required for this group!");
							setHasCreateClick(false);
							return;
						}
					}
					// PRIORITY 3: ALT ID mode
					else {
						const cleanSSN = employee.SSN?.replace(/-/g, "") || "";
						const hasRealSSN = cleanSSN.length === 9;

						if (hasRealSSN) {
							// Optional SSN provided in ALT ID mode
							ssnForPayload = cleanSSN;
							actualSSN = cleanSSN;
						} else if (employee.alt_id) {
							// Using ALT ID
							ssnForPayload = employee.alt_id;
							actualSSN = "";
							// actualSSN = employee.alt_id;
						} else {
							alert("Either SSN or ALT ID is required!");
							setHasCreateClick(false);
							return;
						}
					}

					console.log("Final Payload Values:", {
						ssnForPayload,
						actualSSN,
						altIdForPayload,
						isSSNMode,
						employeeSSN: employee.SSN,
						employeeAltId: employee.alt_id
					});

					// const actualSSN = employee.SSN?.replace(/-/g, "") || ssnForPayload.replace(/@$/, "");
					const { employment_start_date, paycheck_start_date } = paycheck;
					const employmentStartDate = new Date(employment_start_date);
					// const employmentEndDate = employment_end_date ? new Date(employment_end_date) : null;
					const paycheckStartDate = new Date(paycheck_start_date);
					// const paycheckEndDate = paycheck_end_date ? new Date(paycheck_end_date) : null;
					// console.log("Exist Member", JSON.parse(JSON.stringify(employee)));
					// employee.actual_SSN = employee["SSN"]
					// 	? employee["SSN"].replace(/-/g, "")
					// 	: employee.SSN.replace(/-/g, "");
					// employee.SSN = employee["alt_id"] ? employee["alt_id"] : employee.SSN.replace(/-/g, "");
					delete employee["alt_id"];
					const payload = {
						employee: {
							...employee,
							date_of_birth: DOB.getFullYear() + "-" + (DOB.getMonth() + 1) + "-" + DOB.getDate(),
							hire_date:
								hireDate.getFullYear() + "-" + (hireDate.getMonth() + 1) + "-" + hireDate.getDate(),
							// SSN:
							// 	existMember?.role === "DEPENDENT"
							// 		? employee.SSN.replaceAll("-", "").concat("@")
							// 		: employee.SSN.replaceAll("-", ""),
							actual_SSN: actualSSN,
							SSN: ssnForPayload,

							ZIP: employee.ZIP.replaceAll("-", ""),
							is_test: isTestEmployee
						},
						paycheck: {
							...paycheck,
							group_number: employee.group_number,
							employment_start_date:
								employmentStartDate.getFullYear() +
								"-" +
								(employmentStartDate.getMonth() + 1) +
								"-" +
								employmentStartDate.getDate(),
							// employment_end_date:
							// employmentEndDate !== null
							// ? employmentEndDate.getFullYear() +
							//  "-" +
							//  (employmentEndDate.getMonth() + 1) +
							//  "-" +
							//  employmentEndDate.getDate()
							// : employmentEndDate,
							paycheck_start_date:
								paycheckStartDate.getFullYear() +
								"-" +
								(paycheckStartDate.getMonth() + 1) +
								"-" +
								paycheckStartDate.getDate()
							// paycheck_end_date:
							// paycheckEndDate !== null
							// ? paycheckEndDate.getFullYear() +
							//  "-" +
							//  (paycheckEndDate.getMonth() + 1) +
							//  "-" +
							//  paycheckEndDate.getDate()
							// : paycheckEndDate
						}
					};

					// console.log("Payload", payload);
					const response: any = await trackPromise(api.auth.createEmployee(payload));

					if (response) {
						setHasCreateClick(true);
						// console.log("Response", response);

						setEmployee(Object.assign({}, response.employeeData));
						setPaycheck(Object.assign({}, response.paycheckData));

						// alert("Employee Created Successfully!");
						setSnackbarAPICallProps(
							Object.assign({}, snackbarAPICallProps, {
								open: true,
								message: "Employee created Successfully!",
								severity: "success"
							})
						);

						setTimeout(() => {
							handleReturnToMembers();
						}, 2000);
					}
				} else {
					setHasCreateClick(false);
				}
			} catch (error) {
				setHasCreateClick(false);
				alert("Employee creation unsuccessful!");
				throw error;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			employee,
			handleValidation,
			history,
			paycheck,
			snackbarAPICallProps,
			isTestEmployee,
			queryGroupNumber,
			altIdForPayload,
			selectedGroup,
			ssnProvidedByGroup
		]
	);

	const handleHyphenInZip = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "-") {
			event.preventDefault();
		}
	};

	const handleGenerateAltId = async () => {
		try {
			const getAlternateIDQuery = {
				group_number: queryGroupNumber,
				first_name: employee.first_name,
				last_name: employee.last_name,
				date_of_birth: employee.date_of_birth
			};

			const response: any = await trackPromise(api.alternateID.getAlternateID(getAlternateIDQuery as any));
			console.log("alternateIDResponse=====>", response);

			if (response?.exists === true) {
				const existingMember = response.member;
				const altId = response.alternate_ID;

				// Check if existing member is an EMPLOYEE
				if (existingMember?.role === "DEPENDENT") {
					// Store the ALT-ID with @ suffix for payload use only (not UI)
					const altIdWithSuffix = altId + "@";
					setAltIdForPayload(altIdWithSuffix);

					// Store member data for the modal
					setIdentityConflictMemberData({
						first_name: existingMember.first_name,
						last_name: existingMember.last_name,
						date_of_birth: employee.date_of_birth,
						role: existingMember.role,
						relationship: employee.relationship,
						_id: existingMember._id,
						id: existingMember.id,
						alt_id: altId // Clean version without @
					});

					// Set the clean alt_id in form (WITHOUT @ - user sees clean version)
					handleEmployeeChange({
						target: {
							name: "alt_id",
							value: altId
						}
					} as React.ChangeEvent<HTMLInputElement>);

					// Open the identity conflict modal
					setShowIdentityConflictModal(true);
					return;
				}

				// If exists but not an employee, show the regular alt ID exists modal
				setExistingAltId(altId);
				setAltIdModalOpen(true);

				// Auto-assign the clean value to the form
				handleEmployeeChange({
					target: {
						name: "alt_id",
						value: altId
					}
				} as React.ChangeEvent<HTMLInputElement>);

				return;
			}

			// No conflict - generate new ALT ID
			if (response?.alternate_ID) {
				// Clear any previous payload override
				setAltIdForPayload("");

				handleEmployeeChange({
					target: {
						name: "alt_id",
						value: response.alternate_ID
					}
				} as React.ChangeEvent<HTMLInputElement>);

				setSnackbarAPICallProps(
					Object.assign({}, snackbarAPICallProps, {
						open: true,
						message: "New Alternate ID generated successfully!",
						severity: "success"
					})
				);
			}
		} catch (error: any) {
			console.error("Error generating ALT ID:", error);
		}
	};

	const getRateTypeOptions = (pay_frequency: string) => {
		const found = paycheckConfig.find((item) => item.pay_frequency === pay_frequency);
		return found?.rate_type || [];
	};

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.create_employee);
		getAssignGroups();
	}, [getAssignGroups, setDashboardHeader]);

	useEffect(() => {
		handleSelectGroup();
	}, [handleSelectGroup]);

	useEffect(() => {
		setSelectedGroupLocation(Object.assign([], selectedGroup?.assigned_locations));
	}, [selectedGroup]);

	useEffect(() => {
		if (employee.date_of_birth === null) setEmployee(Object.assign({}, employee, { date_of_birth: "" }));

		if (employee.hire_date === null) setEmployee(Object.assign({}, employee, { hire_date: "" }));

		if (paycheck.employment_start_date === null)
			setPaycheck(Object.assign({}, paycheck, { employment_start_date: "" }));

		if (paycheck.paycheck_start_date === null)
			setPaycheck(Object.assign({}, paycheck, { paycheck_start_date: "" }));

		// if (paycheck.paycheck_end_date === null) setPaycheck(Object.assign({}, paycheck, { paycheck_end_date: "" }));
	}, [employee, paycheck]);

	useEffect(() => {
		//alert("Here");
		setEmployeeForm(
			Object.assign(
				{},
				{
					"Group Information": [
						{
							schema: "employee",
							label: "Group",
							name: "group_number",
							onChange: () => null,
							value: employee.group_number,
							type: "textfield"
							// options: [...assignedGroups]
						}
					],
					"Profile Information": [
						{
							schema: "employee",
							label: "Employee ID",
							name: "member_id",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter employee Id",
							value: employee.member_id,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "First Name",
							name: "first_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter first name",
							value: employee.first_name,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "Middle Name",
							name: "middle_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter middle name",
							value: employee.middle_name,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "Last Name",
							name: "last_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter last name",
							value: employee.last_name,
							type: "textfield",
							controlled: false
						},

						...(ssnProvidedByGroup || selectedGroup?.SSN_provided_by_group === true
							? [
									{
										schema: "employee",
										label: "SSN",
										name: "SSN",
										onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
											handleEmployeeChange(event),
										placeholder: "Enter SSN",
										value: employee.SSN,
										type: "textfield",
										controlled: true,
										required: true
									},
									{
										schema: "employee",
										label: "Re-Enter SSN",
										name: "re_enter_SSN",
										onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
											handleReEnterSSNChange(event),
										placeholder: "Re-Enter SSN",
										value: reEnterSSN,
										type: "textfield",
										controlled: true,
										required: true
									}
							  ]
							: []),

						...(ssnProvidedByGroup || selectedGroup?.SSN_provided_by_group === true
							? [] // Don't show ALT ID when SSN is required
							: [
									{
										schema: "employee",
										label: "ALT-ID",
										name: "alt_id",
										onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
											handleEmployeeChange(event),
										placeholder: "Enter ALT-ID",
										value: employee.alt_id,
										type: "textfield",
										controlled: true,
										showGenerateAltId: true
									}
							  ]),

						{
							schema: "employee",
							label: "Date of Birth",
							name: "date_of_birth",
							onChange: (date: MaterialUiPickersDate, name: string) =>
								handleEmployeeDateChange(date, name),
							placeholder: "Enter date of birth",
							value: employee.date_of_birth,
							type: "date"
							//controlled: false,
						},
						// {
						// 	schema: "employee",
						// 	label: "ALT-ID",
						// 	name: "alt_id",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
						// 	placeholder: "Enter ALT-ID",
						// 	value: employee.alt_id,
						// 	type: "textfield",
						// 	controlled: true,
						// 	showGenerateAltId: true
						// },
						{
							schema: "employee",
							label: "Hire Date",
							name: "hire_date",
							onChange: (date: MaterialUiPickersDate, name: string) =>
								handleEmployeeDateChange(date, name),
							placeholder: "Enter hire date",
							value: employee.hire_date,
							type: "date"
							//controlled: false,
						},
						{
							schema: "employee",
							label: "Gender",
							name: "gender",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter gender",
							value: employee.gender,
							type: "select",
							options: GENDERS
							//controlled: false,
						},
						{
							schema: "employee",
							label: "Marital Status",
							name: "marital_status",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter marital status",
							value: employee.marital_status,
							type: "select",
							options: MARITAL_STATUSES
							//controlled: false,
						},
						{
							label: "Tobacco",
							name: "is_tobacco",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
							value: employee.is_tobacco,
							type: "checkbox"
							//controlled: false,
						}
					],
					"Employment Information": [
						{
							schema: "paycheck",
							label: "Employment Start Date",
							name: "employment_start_date",
							onChange: () => null,
							placeholder: "Enter employment start date",
							value:
								paycheck.employment_start_date !== ""
									? prefixCharacterAddition(new Date(paycheck.employment_start_date).getMonth() + 1) +
									  "/" +
									  prefixCharacterAddition(new Date(paycheck.employment_start_date).getDate()) +
									  "/" +
									  new Date(paycheck.employment_start_date).getFullYear()
									: paycheck.employment_start_date,
							type: "textfield"
						},
						// {
						// schema: "paycheck",
						// label: "Employment End Date",
						// name: "employment_end_date",
						// onChange: (date: MaterialUiPickersDate, name: string) =>
						// handlePaycheckDateChange(date, name),
						// placeholder: "Enter employment end date",
						// value: paycheck.employment_end_date,
						// type: "date"
						// },
						{
							schema: "paycheck",
							label: "Employee Class",
							name: "employee_class",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							placeholder: "Enter employee class",
							value: paycheck.employee_class,
							type: "select",
							// options: EMPLOYEE_CLASS
							options: employeeClassConfig
						}
					],
					"Paycheck Information": [
						{
							schema: "employee",
							label: "Location",
							name: "location_number",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							// placeholder: "Enter location",
							value: employee.location_number,
							type: "select",
							options: [...selectedGroupLocation]
						},
						{
							schema: "paycheck",
							label: "Paycheck Start Date",
							name: "paycheck_start_date",
							onChange: () => null,
							placeholder: "Enter paycheck start date",
							value:
								paycheck.paycheck_start_date !== ""
									? prefixCharacterAddition(new Date(paycheck.paycheck_start_date).getMonth() + 1) +
									  "/" +
									  prefixCharacterAddition(new Date(paycheck.paycheck_start_date).getDate()) +
									  "/" +
									  new Date(paycheck.paycheck_start_date).getFullYear()
									: paycheck.paycheck_start_date,
							type: "textfield"
						},
						// {
						// schema: "paycheck",
						// label: "Paycheck End Date",
						// name: "paycheck_end_date",
						// onChange: (date: MaterialUiPickersDate, name: string) =>
						// handlePaycheckDateChange(date, name),
						// placeholder: "Enter paycheck end date",
						// value: paycheck.paycheck_end_date,
						// type: "date"
						// },
						{
							schema: "paycheck",
							label: "Pay Frequency",
							name: "pay_frequency",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							placeholder: "Enter pay frequency",
							value: paycheck.pay_frequency,
							type: "select",
							// options: queryGroupNumber == 225 ? PAY_FREQUENCIES_V2 : PAY_FREQUENCIES
							options: paycheckConfig.map((item) => item.pay_frequency)
						},
						{
							schema: "paycheck",
							label: "Rate Type",
							name: "rate_type",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
								if (paycheck.pay_frequency === "") {
									// console.log("Event", event);
									// console.log("Event before", event.target);
									//event.target.name = "";
									event.target.value = "";
									// console.log("Event after", event.target);
									// console.log("Paycheck Event after", paycheck);
									alert("Please select Pay Frequency first!");
									return;
								} else {
									handlePaycheckChange(event);
								}
							},
							placeholder: "Enter rate type",
							value: paycheck.rate_type,
							type: "select",
							// options: RATE_TYPES
							// options: Array.from(new Set(paycheckConfig.flatMap((rate) => rate.rate_type)))
							options: getRateTypeOptions(paycheck.pay_frequency)
						},
						// ...(queryGroupNumber === 225
						// 	? []
						// 	: [
						// {
						// 	schema: "paycheck",
						// 	label: "Monthly Base Rate",
						// 	name: "monthly_base_rate",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
						// 		handlePaycheckChange(event),
						// 	value: paycheck.monthly_base_rate,
						// 	type: "textfield"
						// },
						{
							schema: "paycheck",
							label: "Hourly Base Pay Rate",
							name: "hourly_base_pay_rate",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							value: paycheck.hourly_base_pay_rate,
							type: "textfield"
						},
						{
							schema: "paycheck",
							label: "Base Pay Rate",
							name: "base_pay_rate",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							value: paycheck.base_pay_rate,
							type: "textfield"
						},
						// {
						// 	schema: "paycheck",
						// 	label: "Weekly Base Rate",
						// 	name: "weekly_base_rate",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
						// 		handlePaycheckChange(event),
						// 	value: paycheck.weekly_base_rate,
						// 	type: "textfield"
						// }
						//   ]),
						{
							schema: "paycheck",
							label: "Buy Up Eligibility",
							name: "buy_up_eligibility",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handlePaycheckChange(event),
							placeholder: "Enter buy up eligibility",
							value: paycheck.buy_up_eligibility,
							type: "select",
							options: ["Yes", "No"]
						}
					],
					"Contact Information": [
						{
							schema: "employee",
							label: "Contact Label",
							name: "contact_label",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter contact label",
							value: employee.contact_label,
							type: "select",
							options: CONTACT_LABELS
						},
						{
							schema: "employee",
							label: "Email",
							name: "email",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter email",
							value: employee.email,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "Phone Number",
							name: "phone_number",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter phone number",
							value: employee.phone_number,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "Phone Extension",
							name: "phone_extension",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter phone extension",
							value: employee.phone_extension,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "Address Line 1",
							name: "address_line_1",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter address line 1",
							value: employee.address_line_1,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "Address Line 2",
							name: "address_line_2",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter address line 2",
							value: employee.address_line_2,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "City",
							name: "city",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter city",
							value: employee.city,
							type: "textfield",
							controlled: false
						},
						{
							schema: "employee",
							label: "State",
							name: "state",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter state",
							value: employee.state,
							type: "select",
							options: STATES
						},
						{
							schema: "employee",
							label: "Country",
							name: "country",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter country",
							value: "USA - United States of America",
							type: "textfield"
						},
						{
							schema: "employee",
							label: "ZIP Code",
							name: "ZIP",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEmployeeChange(event),
							placeholder: "Enter ZIP",
							value: employee.ZIP,
							type: "textfield"
						}
					]
				}
			)
		);
	}, [
		employee,
		paycheck,
		handleEmployeeChange,
		handleEmployeeDateChange,
		handlePaycheckDateChange,
		handlePaycheckChange,
		assignedGroups,
		selectedGroupLocation,
		handleWeeklyPaycheckChange,
		reEnterSSN,
		handleReEnterSSNChange,
		handleEnableCheckbox,
		paycheckConfig,
		employeeClassConfig,
		queryGroupNumber,
		ssnProvidedByGroup,
		selectedGroup,
		altIdForPayload
	]);

	// console.log("Paycheck", paycheck);
	// console.log("Pasted", pasted);
	// console.log("Selected Group", selectedGroup);
	// console.log("Selected Group Location", selectedGroupLocation);

	// console.log("CheckEXIST-->", existMember);
	// console.log("paycheckConfig=====>", paycheckConfig, getRateTypeOptions(paycheck.pay_frequency));

	return (
		<>
			<div className="create-employee" id="create-employee">
				<Suspense fallback={<div />}>
					<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
				</Suspense>
				<div
					className="pf-action-button-container"
					id="pf-action-button-container"
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "flex-end",
						justifyContent: "flex-end"
					}}
				>
					<CustomizedSwitches
						checked={isTestEmployee}
						onChange={(event: any) => setIsTestEmployee(event.target.checked)}
						label="Test Employee"
					/>
					<Button
						className="button-green"
						onClick={handleCreateEmployee}
						variant="contained"
						disabled={hasCreateClick || !!existingAltId} // ✅ Convert string to boolean
						disableElevation={hasCreateClick || !!existingAltId}
						style={{
							cursor: hasCreateClick || !!existingAltId ? "not-allowed" : "pointer",
							pointerEvents: "unset"
						}}
					>
						<span className="button-label-with-icon">Create Employee </span>
						<span>
							<PersonAddIcon className="button-icon" />
						</span>
					</Button>
				</div>
				<Grid container spacing={1} className="pf-grid-container">
					{employeeForm &&
						Object.entries(employeeForm).map(([key, value], index) => {
							return (
								<div key={index}>
									<div className="pf-title">{key}</div>
									<Suspense fallback={<div />}>
										<Paper className="pf-paper-container" elevation={3} variant="outlined">
											{value.map((field, index) => {
												return (
													<Grid item key={index} xl={12} lg={12} md={12} sm={12} xs={12}>
														<Grid
															container
															spacing={1}
															className="pf-label"
															style={{
																display:
																	field.name === "monthly_base_rate"
																		? paycheck.pay_frequency ===
																		  PAY_FREQUENCY.weekly
																			? "none"
																			: ""
																		: field.name === "weekly_base_rate"
																		? paycheck.pay_frequency ===
																		  PAY_FREQUENCY.monthly
																			? "none"
																			: ""
																		: ""
															}}
														>
															<Grid
																item
																xs={field.name === "is_tobacco" ? undefined : 12}
																sm={field.name === "is_tobacco" ? undefined : 12}
																md={field.name === "is_tobacco" ? undefined : 3}
																lg={field.name === "is_tobacco" ? undefined : 3}
																xl={field.name === "is_tobacco" ? undefined : 3}
															>
																<div
																	className={
																		field.name === "middle_name" ||
																		field.name === "address_line_2" ||
																		field.name === "paycheck_end_date" ||
																		field.name === "phone_extension" ||
																		field.name === "is_tobacco"
																			? "pf-label-text"
																			: "pf-label-text required"
																	}
																	id="pf-label-text"
																>
																	{field.name === "is_tobacco" ? "" : field.label}
																</div>
															</Grid>
															<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
																{field.type === "textfield" ? (
																	field.name === "alt_id" &&
																	(field as any).showGenerateAltId ? (
																		//  ACTUAL SSN WITH GENERATE BUTTON
																		<Grid container spacing={1} alignItems="center">
																			<Grid item>
																				<TextField
																					className="text-field"
																					id="input-text-field"
																					name={field.name}
																					placeholder={field.placeholder}
																					value={field.value}
																					onChange={field.onChange}
																					variant="outlined"
																					helperText={
																						validation.employee?.alt_id
																					}
																					style={{ width: "340px" }}
																				/>
																			</Grid>

																			<Grid item xs={4}>
																				<div
																					style={{
																						position: "relative",
																						display: "inline-block",
																						width: "100%"
																					}}
																					onMouseEnter={() => {
																						if (
																							!employee.first_name ||
																							!employee.last_name ||
																							!employee.date_of_birth
																						) {
																							setShowTooltip(true);
																						}
																					}}
																					onMouseLeave={() =>
																						setShowTooltip(false)
																					}
																				>
																					<Button
																						variant={
																							field.value
																								? "outlined"
																								: "contained"
																						}
																						color="primary"
																						onClick={handleGenerateAltId}
																						disabled={
																							Boolean(field.value) ||
																							!employee.first_name ||
																							!employee.last_name ||
																							!employee.date_of_birth
																						}
																						style={{
																							height: 36,
																							textTransform: "none",
																							fontWeight: 500,
																							fontSize: "0.8rem",
																							boxShadow: field.value
																								? "none"
																								: "0 1px 2px rgba(0,0,0,0.15)",
																							backgroundColor: field.value
																								? "transparent"
																								: "#2e7d32",
																							color: field.value
																								? "#2e7d32"
																								: "#fff",
																							borderColor: "#2e7d32",
																							borderWidth: 1.5,
																							cursor:
																								Boolean(field.value) ||
																								!employee.first_name ||
																								!employee.last_name ||
																								!employee.date_of_birth
																									? "not-allowed"
																									: "pointer",
																							opacity:
																								Boolean(field.value) ||
																								!employee.first_name ||
																								!employee.last_name ||
																								!employee.date_of_birth
																									? 0.7
																									: 1
																						}}
																						startIcon={
																							<AssignmentIndIcon />
																						}
																					>
																						{field.value
																							? "ID Assigned"
																							: // : "Generate ALT ID"
																							  "Generate SSN"}
																					</Button>

																					{/* Tooltip for missing required fields */}
																					{showTooltip &&
																						!field.value &&
																						(!employee.first_name ||
																							!employee.last_name ||
																							!employee.date_of_birth) && (
																							<div
																								style={{
																									position:
																										"absolute",
																									bottom: "100%",
																									left: "20%",
																									transform:
																										"translateX(-50%)",
																									marginBottom: "8px",
																									padding: "8px 12px",
																									backgroundColor:
																										"#374151",
																									color: "#fff",
																									fontSize: "0.75rem",
																									borderRadius: "6px",
																									whiteSpace:
																										"nowrap",
																									zIndex: 1000,
																									boxShadow:
																										"0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
																									animation:
																										"fadeIn 0.2s ease-in-out"
																								}}
																							>
																								<span
																									style={{
																										fontWeight: 600
																									}}
																								>
																									Please fill in:
																								</span>
																								<ul
																									style={{
																										margin: "4px 0 0 0",
																										paddingLeft:
																											"16px",
																										listStyle:
																											"disc",
																										lineHeight:
																											"1.5"
																									}}
																								>
																									{!employee.first_name && (
																										<li>
																											First Name
																										</li>
																									)}
																									{!employee.last_name && (
																										<li>
																											Last Name
																										</li>
																									)}
																									{!employee.date_of_birth && (
																										<li>
																											Date of
																											Birth
																										</li>
																									)}
																								</ul>

																								{/* Tooltip Arrow */}
																								<div
																									style={{
																										position:
																											"absolute",
																										top: "100%",
																										left: "50%",
																										transform:
																											"translateX(-50%)",
																										borderWidth:
																											"6px",
																										borderStyle:
																											"solid",
																										borderColor:
																											"#374151 transparent transparent transparent"
																									}}
																								/>
																							</div>
																						)}
																				</div>
																			</Grid>
																		</Grid>
																	) : (
																		<TextField
																			className="text-field"
																			id={
																				field.name === "group_number" ||
																				field.name ===
																					"employment_start_date" ||
																				field.name === "paycheck_start_date" ||
																				field.name === "country"
																					? "disabled-input-text-field"
																					: "input-text-field"
																			}
																			type={
																				// field.name === "weekly_base_rate" ||
																				// field.name === "monthly_base_rate" ||
																				field.name === "hourly_base_pay_rate" ||
																				field.name === "base_pay_rate"
																					? "number"
																					: "string"
																			}
																			name={field.name}
																			placeholder={field.placeholder}
																			value={
																				field.name === "group_number"
																					? selectedGroup?.name
																					: field.controlled === false
																					? undefined
																					: field.value
																			}
																			onChange={field.onChange}
																			//onBlur={field.onChange}
																			//onBlur={field.onBlur}
																			onKeyDown={(
																				event: React.KeyboardEvent<HTMLDivElement>
																			) => handleKeyCheck(event)}
																			onPaste={(
																				event: React.ClipboardEvent<HTMLDivElement>
																			) => handlePaste(event)}
																			variant="outlined"
																			disabled={
																				field.name === "group_number" ||
																				field.name ===
																					"employment_start_date" ||
																				field.name === "paycheck_start_date" ||
																				field.name === "country"
																					? true
																					: false
																			}
																			inputProps={{
																				step:
																					field.name ===
																						"hourly_base_pay_rate" ||
																					field.name === "base_pay_rate"
																						? // field.name === "monthly_base_rate" ||
																						  // field.name === "weekly_base_rate"
																						  0.01
																						: null,
																				max:
																					field.name ===
																						"hourly_base_pay_rate" ||
																					field.name === "base_pay_rate"
																						? // field.name === "monthly_base_rate" ||
																						  // field.name === "weekly_base_rate"
																						  999.99
																						: null,
																				onKeyDown:
																					field.name === "ZIP"
																						? handleHyphenInZip
																						: undefined
																			}}
																			InputProps={{
																				startAdornment: (
																					<>
																						{field.name ===
																							"hourly_base_pay_rate" ||
																						field.name ===
																							"base_pay_rate" ? (
																							<InputAdornment position="start">
																								<AttachMoneyIcon />
																							</InputAdornment>
																						) : null}
																					</>
																				),
																				endAdornment: (
																					<>
																						{field.name ===
																							"group_number" ||
																						field.name ===
																							"employment_start_date" ||
																						field.name ===
																							"paycheck_start_date" ||
																						field.name === "country" ? (
																							<InputAdornment position="end">
																								<LightTooltip
																									title={
																										field.name ===
																										"group_number"
																											? infoTitleMessage.group
																											: field.name ===
																											  "employment_start_date"
																											? infoTitleMessage.employment_start_date
																											: field.name ===
																											  "paycheck_start_date"
																											? infoTitleMessage.paycheck_start_date
																											: field.name ===
																											  "country"
																											? infoTitleMessage.country
																											: ""
																									}
																									placement="right-start"
																									arrow
																								>
																									<InfoIcon
																										style={{
																											color: "#808080",
																											fontSize:
																												"20px",
																											// cursor: !showSaveButton
																											// ? "default"
																											// : "pointer",
																											pointerEvents:
																												"unset"
																										}}
																									/>
																								</LightTooltip>
																							</InputAdornment>
																						) : null}
																					</>
																				),
																				readOnly:
																					field.value ===
																					"USA - United States of America"
																						? true
																						: field.name ===
																								"hourly_base_pay_rate" &&
																						  paycheck.rate_type !==
																								RATE_TYPE_V2.hourly_rate
																						? true
																						: // : field.name ===
																						// 		"weekly_base_rate" &&
																						//   paycheck.rate_type !==
																						// 		RATE_TYPE.flat_rate
																						// ? true
																						// : field.name ===
																						// 		"monthly_base_rate" &&
																						//   paycheck.rate_type !==
																						// 		RATE_TYPE.flat_rate
																						field.name ===
																								"base_pay_rate" &&
																						  paycheck.rate_type !==
																								RATE_TYPE_V2.fixed
																						? true
																						: field.name === "group_number"
																						? true
																						: false
																			}}
																			helperText={
																				field.schema === "employee"
																					? emailExists &&
																					  field.name === "email"
																						? "Email exists!"
																						: checkInvalidEmail &&
																						  field.name === "email"
																						? "Please enter a valid email address!"
																						: field.name === "re_enter_SSN"
																						? validation.reEnterSSN
																						: field.name === "member_id" &&
																						  memberIdExists
																						? "Member Id already exists!"
																						: field.name === "SSN" &&
																						  SSNExists
																						? existMember?.role ===
																						  "DEPENDENT"
																							? "SSN already exists!"
																							: "SSN already exists as an employee"
																						: validation.employee[
																								field.name
																						  ]
																					: validation.paycheck[field.name]
																			}
																			//style={{ width: "70%", borderRadius: 50 }}
																			//disabled={!isButtonSelected}
																			//disableElevation={!isButtonSelected}
																			style={{
																				//cursor: !isButtonSelected?"not-allowed": "pointer",
																				pointerEvents: "unset",
																				width: "340px",
																				borderRadius: 50
																			}}
																		/>
																	)
																) : field.type === "select" ? (
																	<>
																		<Select
																			id="text-align-options"
																			name={field.name}
																			onChange={field.onChange}
																			//disabled={!isButtonSelected}
																			//disableElevation={!isButtonSelected}
																			style={{
																				//cursor: !isButtonSelected ? "not-allowed" : "pointer",
																				pointerEvents: "unset",
																				minWidth: 180,
																				textAlign: "left",
																				// zIndex: 10000,
																				overflowY: "visible"
																			}}
																			MenuProps={{
																				style: { zIndex: 35960 }
																			}}
																			inputProps={{
																				"aria-label": "Without label"
																			}}
																		>
																			<MenuItem value="" disabled>
																				Select Value
																			</MenuItem>
																			{field.name === "location_number"
																				? field?.options?.map(
																						(
																							location: any,
																							index: number
																						) => {
																							const {
																								location_name,
																								location_number
																							} = location;
																							return (
																								<MenuItem
																									value={
																										location_number
																									}
																									key={index}
																								>
																									<span className="location-number-menu-item">{`${location_number}`}</span>
																									<span className="location-name-menu-item">{`- ${location_name}`}</span>
																								</MenuItem>
																							);
																						}
																				  )
																				: field?.options?.map((option: any) => (
																						<MenuItem
																							key={option}
																							value={
																								field.name ===
																								"group_number"
																									? option.group_number
																									: field.name ===
																											"rate_type" &&
																									  paycheck.pay_frequency ===
																											""
																									? ""
																									: option
																							}
																						>
																							{field.name ===
																							"group_number"
																								? option.name
																								: field.name ===
																								  "pay_frequency"
																								? initCapitalize(
																										option as string
																								  )
																								: field.name ===
																								  "rate_type"
																								? initCapitalize(
																										option as string
																								  )
																								: field.name ===
																								  "gender"
																								? initCapitalize(
																										option as string
																								  )
																								: field.name ===
																								  "marital_status"
																								? initCapitalize(
																										option as string
																								  )
																								: field.name ===
																								  "contact_label"
																								? initCapitalize(
																										option as string
																								  )
																								: option}
																						</MenuItem>
																				  ))}
																		</Select>
																		{field.schema === "employee" ? (
																			validation &&
																			validation.employee[field.name] ? (
																				<div className="details">
																					<span className="select-validation-text2">
																						{
																							validation.employee[
																								field.name
																							]
																						}
																					</span>
																				</div>
																			) : null
																		) : validation &&
																		  validation.paycheck[field.name] ? (
																			<div className="details">
																				<span className="select-validation-text2">
																					{validation.paycheck[field.name]}
																				</span>
																			</div>
																		) : null}
																	</>
																) : field.type === "date" ? (
																	<MuiPickersUtilsProvider utils={DateFnsUtils}>
																		<KeyboardDatePicker
																			className="from-date-input"
																			id="from-date-input"
																			inputVariant="outlined"
																			label={field.label}
																			placeholder={field.placeholder}
																			name={field.name}
																			format="MM/dd/yyyy"
																			error={false}
																			value={field.value}
																			maxDate={
																				field.name === "paycheck_start_date" ||
																				field.name ===
																					"employment_start_date" ||
																				field.name === "date_of_birth" ||
																				field.name === "hire_date"
																					? maxDateRange
																					: undefined
																			}
																			readOnly={
																				field.name ===
																					"employment_start_date" ||
																				field.name === "paycheck_start_date"
																					? true
																					: false
																			}
																			onChange={(date: MaterialUiPickersDate) =>
																				field.onChange(date, field.name)
																			}
																			InputProps={{
																				startAdornment: (
																					<IconButton
																						onClick={(
																							event: React.MouseEvent<
																								HTMLButtonElement,
																								MouseEvent
																							>
																						) =>
																							handleClearDateField(
																								event,
																								field.name,
																								field.schema as string
																							)
																						}
																						style={{ order: 1 }}
																					>
																						<ClearIcon
																							color="disabled"
																							fontSize="small"
																						/>
																					</IconButton>
																				),
																				readOnly: true
																			}}
																			InputLabelProps={{
																				shrink: true
																			}}
																			//style={{ width: "340px", borderRadius: 50 }}
																			keyboardIcon={
																				<EventIcon
																					style={{
																						color: "#7cb342"
																					}}
																				/>
																			}
																			KeyboardButtonProps={{
																				"aria-label": "change date"
																			}}
																			// disabled={!isButtonSelected}
																			// disableElevation={!isButtonSelected}
																			style={{
																				// cursor: !isButtonSelected ? "not-allowed" : "pointer",
																				pointerEvents: "unset",
																				width: "340px",
																				borderRadius: 50
																			}}
																			helperText={
																				field.schema === "employee"
																					? validation.employee[field.name]
																					: validation.paycheck[field.name]
																			}
																		/>
																	</MuiPickersUtilsProvider>
																) : field.type === "checkbox" ? (
																	<>
																		<div
																			className="check-support"
																			id="check-support"
																		>
																			<span>
																				<GreenCheckbox
																					onChange={field.onChange}
																					name={field.name}
																					checked={field.value}
																				/>
																			</span>
																			<span
																				className="pf-label-text"
																				id="pf-label-text"
																			>
																				{field.label}
																			</span>
																		</div>
																	</>
																) : null}
															</Grid>
														</Grid>
													</Grid>
												);
											})}
										</Paper>
									</Suspense>
								</div>
							);
						})}
				</Grid>
				<div
					className="pf-action-button-container margin-top-action-button"
					id="pf-action-button-container"
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "flex-end",
						justifyContent: "flex-end"
					}}
				>
					<CustomizedSwitches
						checked={isTestEmployee}
						onChange={(event: any) => setIsTestEmployee(event.target.checked)}
						label="Test Employee"
					/>

					<Button
						className="button-green"
						onClick={handleCreateEmployee}
						variant="contained"
						disabled={hasCreateClick || !!existingAltId} //  Convert string to boolean
						disableElevation={hasCreateClick || !!existingAltId}
						style={{
							cursor: hasCreateClick || !!existingAltId ? "not-allowed" : "pointer",
							pointerEvents: "unset"
						}}
					>
						<span className="button-label-with-icon">Create Employee</span>
						<span>
							<PersonAddIcon className="button-icon" />
						</span>
					</Button>
				</div>
			</div>

			{((SSNExists && existMember?.role === "EMPLOYEE") || altIdModalOpen) && (
				<ExistsOwnMemberModel
					onClose={() => {
						if (SSNExists) {
							setIsModalOpen(false);
							setSSNExists(false);
							setExistMember(undefined);
							// Clear the SSN field so user can try again
							handleEmployeeChange({
								target: {
									name: "SSN",
									value: ""
								}
							} as React.ChangeEvent<HTMLInputElement>);
						} else {
							setAltIdModalOpen(false);
							setExistingAltId("");
							// Clear the alt_id field so user can try again or generate new
							handleEmployeeChange({
								target: {
									name: "alt_id",
									value: ""
								}
							} as React.ChangeEvent<HTMLInputElement>);
						}
					}}
					existingAltId={SSNExists ? employee.SSN : existingAltId}
					employeeName={`${employee.first_name} ${employee.last_name}`.trim()}
					isSSN={SSNExists} // TRUE when SSN modal, FALSE when ALT ID modal
				/>
			)}
			{SSNExists && existMember?.role === "DEPENDENT" && (
				<IdentityPersonConversionExistsModal
					open={true}
					onClose={() => {
						setIsModalOpen(false);
						setSSNExists(false);
						setExistMember(undefined);
						handleEmployeeChange({
							target: { name: "SSN", value: "" }
						} as React.ChangeEvent<HTMLInputElement>);
					}}
					onConfirm={() => {
						const ssnWithSuffix = employee.SSN.replace(/-/g, "") + "@";
						setAltIdForPayload(ssnWithSuffix);
						setIsModalOpen(false);
						setSSNExists(false);
					}}
					memberData={{
						first_name: existMember?.first_name,
						last_name: existMember?.last_name,
						date_of_birth: existMember?.date_of_birth,
						role: existMember?.role,
						SSN: employee.SSN // Pass SSN explicitly
					}}
					isSSN={true} // This is SSN mode
					idValue={employee.SSN} // Pass the SSN value
				/>
			)}
			{/* 
			{altIdModalOpen && (
				<ExistsOwnMemberModel
					onClose={() => {
						setAltIdModalOpen(false);
						setExistingAltId(""); // Still good practice to clear this
					}}
					existingAltId={existingAltId}
					employeeName={`${employee.first_name} ${employee.last_name}`.trim()}
				/>
			)} */}

			<IdentityPersonConversionExistsModal
				open={showIdentityConflictModal}
				onClose={() => {
					setShowIdentityConflictModal(false);
					setAltIdForPayload(""); // Clear the payload override
					// Optionally clear the alt_id from form too
					handleEmployeeChange({
						target: {
							name: "alt_id",
							value: ""
						}
					} as React.ChangeEvent<HTMLInputElement>);
				}}
				onConfirm={handleIdentityConflictConfirm}
				memberData={identityConflictMemberData}
			/>
		</>
	);
};

export default CreateEmployee;
